<template>
  <div
    class="main-search"
    :class="(!ontop || focused)? 'focused': ''"
    @click="stopPropagation"
  >
    <div class="main-search--input">
      <input
        id="search"
        ref="searchField"
        v-model="keyword"
        size="sm"
        type="search"
        trim
        autocomplete="off"
        :placeholder="$t('search.placeholder')"
        @click="focusSearch"
        @focus="focusSearch"
        @keyup="startSearchKeyword"
      >
    </div>
    <div
      v-if="focused && keywords.length > 0"
      class="main-search--dropdown"
    >
      <div class="main-search--results">
        <!-- <h3 class="tiny-caps">All results</h3> -->
        <div class="main-search--suggestions">
          <div
            v-for="(search_result, i) in keywords"
            :id="`keyword${search_result.id}`"
            :key="`keyword${search_result.id}`"
            class="main-search--suggestion"
            :class="activeIndex === i? 'selected': ''"
            @click="selectKeyword($event, search_result.text)"
          >
            {{ search_result.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  name: "SearchBox",
  props: ["ontop"],
  data: function() {
    return {
      focused: false,
      prevKeyword: null,
      keyword: null,
      keywords: [],
      activeIndex: -1
    };
  },
  methods: {
    focusSearch(e) {
      this.stopPropagation(e);
      this.focused = true;
      if (_.isEmpty(this.keywords)) {
        this.searchKeyword();
      }
      setTimeout(() => {
        document
          .getElementById("app")
          .addEventListener("click", this.leaveSearch, false);
      }, 250);
    },
    stopPropagation(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    selectKeyword(e, keyword) {
      this.stopPropagation(e);
      this.keyword = keyword;
      this.keywords = [];
      this.activeIndex = -1;
      this.leaveSearch(e);
      this.search();
    },
    //eslint-disable-next-line
    leaveSearch(e) {
      this.focused = false;
      this.$refs["searchField"].blur();
      setTimeout(() => {
        document
          .getElementById("app")
          .removeEventListener("click", this.leaveSearch, false);
      }, 250);
    },
    cancel() {
      if (this.request) {
        this.request.cancel("Cancel Previous Request");
      }
    },
    search() {
      if (_.isEmpty(this.keyword)) return;
      var to = this.$router.history.current;
      if (to.name == "search" && to.params.type != null) {
        this.$router.push("/search/" + to.params.type + "?q=" + this.keyword);
      } else {
        this.$router.push("/search/events?q=" + this.keyword);
      }
    },
    startSearchKeyword(e) {
      switch (e.keyCode) {
        case 13: // Enter
          this.leaveSearch(e);
          if (!_.isEmpty(this.keywords) && this.activeIndex != -1) {
            this.keyword = this.keywords[this.activeIndex].text;
          }
          this.search();
          break;
        case 38: // Move Up
          if (this.keyword && this.keywords.length > 0) {
            let activeIndex = this.activeIndex;
            activeIndex--;
            if (activeIndex < 0) {
              activeIndex = this.keywords.length - 1;
            }
            this.activeIndex = activeIndex;
          }
          break;
        case 40: // Move Down
          if (this.keyword && this.keywords.length > 0) {
            let activeIndex = this.activeIndex;
            activeIndex++;
            if (activeIndex >= this.keywords.length) {
              activeIndex = 0;
            }
            this.activeIndex = activeIndex;
          }
          break;
        case 37: // Move Left
        case 39: // Move Right
          this.activeIndex = -1;
          break;
        default:
          if (this.prevKeyword != this.keyword) {
            this.prevKeyword = this.keyword;
            this.searchKeyword();
          }
          break;
      }
    },
    searchKeyword() {
      if (!_.isEmpty(this.keyword)) {
        this.request = this.CancelToken.source();
        var getOptions = { cancelToken: this.request.token };
        this.cancel();
        let __this = this;
        this.$http
          .get("autocomplete", { params: { q: this.keyword } }, getOptions)
          .then(response => {
            if (response.data.success) {
              __this.activeIndex = -1;
              __this.keywords = response.data.data;
            }
          })
          .catch(error => {
            console.log(error);
            __this.keywords = [];
          });
      }
    }
  }
};
</script>
<style lang="scss" src='../assets/scss/search-box.scss'></style>